import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { LoadingTextIndicator } from '@web/components/LoadingTextIndicator/LoadingTextIndicator';
import { useGetAnnouncements } from '@web/announcements/hooks/useGetAnnouncements';

import { Button, Info, Wrapper } from './loadMore.styles';

export const LoadMore = () => {
  const { fetchNextPage, hasNextPage, isFetchingNextPage } = useGetAnnouncements();

  return hasNextPage ? (
    <Wrapper>
      <Info>{gettext('Older announcements are automatically archived.')}</Info>

      {isFetchingNextPage ? (
        <LoadingTextIndicator color={ThemeColorType.primary} />
      ) : (
        <Button onClick={() => fetchNextPage()}>{gettext('Load more')}</Button>
      )}
    </Wrapper>
  ) : null;
};
